import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadBibleVerse } from "../../redux/actions/bibleVerseActions";

export default function BibleVerse() {
  const dispatch = useDispatch();
  const bibleVerse = useSelector(state => state.bibleVerse);

  useEffect(() => {
    if (
      !bibleVerse ||
      new Date(bibleVerse.lastFetched) <= new Date().setHours(0, 0, 0, 0)
    ) {
      fetchBibleVerse();
    } else {
      console.log(bibleVerse);
    }
  }, []);

  async function fetchBibleVerse() {
    const response = await dispatch(loadBibleVerse());
    console.log(response);
  }

  return (
    <div className="bible-verse">
      <span className="bible-label">Dagens bibelord:</span>
      <span className="verse">
        {bibleVerse.verse}
      </span>
      <a className="bibel_link" href={bibleVerse.bibleRefUrl}>
        {bibleVerse.bibleRef}
      </a>
    </div>
  );
}
